import Error from '@paybis/frontend-common-lib/src/components/error.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    { path: '/error', name: 'error', component: Error },
  ],
  mode: 'abstract',
});

export default router;

